import { useCallback, useMemo } from 'react';
import { getI18n } from 'react-i18next';
import { LangOption } from '@/types/global';
import { isBrowser } from '@/utils/util_helpers/ssr';

const localeOptionsFull: {
  [key in LangOption]: string;
} = {
  en: 'English (EN)',
  fr: 'Français (FR)',
  nl: 'Nederlands (NL)',
};

const useLocale = () => {
  const i18n = getI18n();

  const currentLocale = useMemo(() => {
    return i18n.language;
  }, [i18n.language]);

  const setLocale = useCallback(
    (locale: LangOption) => {
      if (!isBrowser()) return;

      const pathName = window.location.pathname;
      let newPathName = pathName;

      if (currentLocale !== locale) {
        if (pathName.includes(`/${currentLocale}/`)) {
          newPathName = pathName.replace(`/${currentLocale}/`, `/${locale}/`);
        } else if (pathName === `/${currentLocale}` || pathName === `/${currentLocale}/`) {
          newPathName = `/${locale}/`;
        } else {
          const stripped = pathName.replace(new RegExp(`^/${currentLocale}(?=/|$)`), '');
          newPathName = `/${locale}${stripped || '/'}`;
        }
      }

      window.location.pathname = newPathName;
    },
    [currentLocale]
  );

  return {
    localeOptionsFull,
    currentLocale,
    setLocale,
  };
};

export { useLocale };
